import { render, staticRenderFns } from "./MastersIncomeOutcomeList.vue?vue&type=template&id=5755acfb&scoped=true"
import script from "./MastersIncomeOutcomeList.vue?vue&type=script&lang=js"
export * from "./MastersIncomeOutcomeList.vue?vue&type=script&lang=js"
import style0 from "./MastersIncomeOutcomeList.vue?vue&type=style&index=0&id=5755acfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5755acfb",
  null
  
)

export default component.exports